// Section 5: Diligent. Output 1.15x in any job. Constants: config.traits.diligent.
import type { Config } from '../../config';
import { mod } from '../../core/modifiers';
import { neverRestricts, targetPerson } from '../../core/content-helpers';
import { defineTrait } from '../../core/registry';

export function diligent(config: Config) {
  return defineTrait({
    id: 'diligent',
    label: 'Diligent',
    section: 'S5',
    modifierTargets: ['output'],
    modifiers(ctx, target) {
      return target.kind === 'output' &&
        targetPerson(ctx, target)?.traits.includes('diligent') === true
        ? [mod.mul('trait:diligent', config.traits.diligent.outputMul, 'diligent')]
        : [];
    },
    restricts: neverRestricts,
  });
}
